<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" :label="label">
        <q-editor v-model="inputValue" @input="onInput"
                  :definitions="definitions"
                  :toolbar="[
                    ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                    ['token', 'hr', 'link', 'custom_btn'],
                    ['print', 'fullscreen'],
                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
                    [
                      {
                        label: $q.i18n.editor.align,
                        icon: $q.icon.editor.align,
                        fixedLabel: true,
                        list: 'only-icons',
                        options: ['left', 'center', 'right', 'justify']
                      },
                      {
                        label: $q.i18n.editor.align,
                        icon: $q.icon.editor.align,
                        fixedLabel: true,
                        options: ['left', 'center', 'right', 'justify']
                      }
                    ],
                    ['undo', 'redo'],
                    [
                      {
                        label: 'Lending Point Variables',
                        icon: 'filter_1',
                        fixedLabel: true,
                        fixedIcon: true,
                        options: ['lendingPointName', 'lendingPointAddress', 'lendingPointEmail', 'lendingPointPhone', 'lendingPointCIF']
                      }
                    ],
                    [
                      {
                        label: 'Consumer Variables',
                        icon: 'filter_1',
                        fixedLabel: true,
                        fixedIcon: true,
                        options: ['consumerFirstName', 'consumerLastName', 'consumerEmail', 'consumerPrefix', 'consumerPhone', 'consumerDNI']
                      }
                    ],
                    [
                      {
                        label: 'Kit Variables',
                        icon: 'filter_1',
                        fixedLabel: true,
                        fixedIcon: true,
                        options: ['kitNumber', 'kitCodentify', 'kitCharger', 'kitHolder', 'kitColor', 'kitModel']
                      }
                    ],
                    [
                      {
                        label: 'Other Variables',
                        icon: 'filter_1',
                        fixedLabel: true,
                        fixedIcon: true,
                        options: ['startLendingAt', 'endLendingAt', 'owner', 'day', 'month', 'year']
                      }
                    ]
                  ]"
        />
    </v-field>
</template>

<script>
    import moment from 'moment'
    import mixins from './mixins'
    import {QEditor} from 'quasar-framework'

    export default {
        name: 'VWyswyg',

        mixins,

        data() {
            return {
                inputValue: this.value || '',
                definitions: {
                    lendingPointName: {
                      label: 'Lending Point Name',
                      tip: 'Lending Point Name',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'lendingPointName'
                    },
                    lendingPointAddress: {
                      label: 'Lending Point Address',
                      tip: 'Lending Point Address',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'lendingPointAddress'
                    },
                    lendingPointEmail: {
                      label: 'Lending Point Email',
                      tip: 'Lending Point Email',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'lendingPointEmail'
                    },
                    lendingPointPhone: {
                      label: 'Lending Point Phone',
                      tip: 'Lending Point Phone',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'lendingPointPhone'
                    },
                    lendingPointCIF: {
                      label: 'Lending Point CIF',
                      tip: 'Lending Point CIF',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'lendingPointCIF'
                    },
                    consumerFirstName: {
                      label: 'Consumer First Name',
                      tip: 'Consumer First Name',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'consumerFirstName'
                    },
                    consumerLastName: {
                      label: 'Consumer Last Name',
                      tip: 'Consumer Last Name',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'consumerLastName'
                    },
                    consumerEmail: {
                      label: 'Consumer Email',
                      tip: 'Consumer Email',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'consumerEmail'
                    },
                    consumerPrefix: {
                      label: 'Consumer Prefix',
                      tip: 'Consumer Prefix',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'consumerPrefix'
                    },
                    consumerPhone: {
                      label: 'Consumer Phone',
                      tip: 'Consumer Phone',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'consumerPhone'
                    },
                    consumerDNI: {
                      label: 'Consumer DNI',
                      tip: 'Consumer DNI',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'consumerDNI'
                    },
                    startLendingAt: {
                      label: 'Start Lending At',
                      tip: 'Start Lending At',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'startLendingAt'
                    },
                    endLendingAt: {
                      label: 'End Lending At',
                      tip: 'End Lending At',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'endLendingAt'
                    },
                    kitNumber: {
                      label: 'Kit Number',
                      tip: 'Kit Number',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'kitNumber'
                    },
                    kitCodentify: {
                      label: 'Kit Codentify',
                      tip: 'Kit Codentify',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'kitCodentify'
                    },
                    kitCharger: {
                      label: 'Kit Charger',
                      tip: 'Kit Charger',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'kitCharger'
                    },
                    kitHolder: {
                      label: 'Kit Holder',
                      tip: 'Kit Holder',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'kitHolder'
                    },
                    kitColor: {
                      label: 'Kit Color',
                      tip: 'Kit Color',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'kitColor'
                    },
                    kitModel: {
                      label: 'Kit Model',
                      tip: 'Kit Model',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'kitModel'
                    },
                    owner: {
                      label: 'Owner',
                      tip: 'Owner',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'owner'
                    },
                    day: {
                      label: 'Current Day',
                      tip: 'Current Day',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'DD'
                    },
                    month: {
                      label: 'Current Month',
                      tip: 'Current Month',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'MM'
                    },
                    year: {
                      label: 'Current Year',
                      tip: 'Current Year',
                      icon: 'label',
                      cmd: 'insertHTML',
                      param: 'YYYY'
                    }
                  }
            }
        },

        components: {
            QEditor
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VWyswyg.vue